import { Link } from "react-router-dom";
import './Doubt.css';

export const Doubt = () => {
    return(
        <>
        <div className="cta-container">
            <h2 className="cta-text">Still Have a Doubt?</h2>
            <Link to="/contact" className="cta-button">
                GET STARTED TODAY
            </Link>
        </div>
        </>
    );
};